// v1: Pure Encapsulations only — signup branding uses bundled assets, not server logos.
// Backend still exposes referralPartnerLogoUrl / ReferralPartner#logo_url for future partners.
export const PURE_ENCAPSULATIONS_NAME = "Pure Encapsulations";

export const isPureEncapsulationsReferralPartner = (referralPartnerName?: string) =>
  referralPartnerName === PURE_ENCAPSULATIONS_NAME;
